import { App, message as staticMessage, notification as staticNotification } from 'antd';

// 全局保存 App 上下文中的 message/notification，用于非组件环境（如 requestErrorConfig）
let messageApi: ReturnType<typeof staticMessage> = staticMessage;
let notificationApi: ReturnType<typeof staticNotification> = staticNotification;
let modalApi: ReturnType<typeof App.useApp>['modal'] | null = null;

export const setAppContext = (ctx: {
  message?: ReturnType<typeof staticMessage>;
  notification?: ReturnType<typeof staticNotification>;
  modal?: ReturnType<typeof App.useApp>['modal'];
}) => {
  if (ctx.message) {
    messageApi = ctx.message;
  }
  if (ctx.notification) {
    notificationApi = ctx.notification;
  }
  if (ctx.modal) {
    modalApi = ctx.modal;
  }
};

export const getAppMessage = () => messageApi;
export const getAppNotification = () => notificationApi;
export const getAppModal = () => modalApi;


